import { defineComponent } from 'vue';
export default defineComponent({
  props: {
    size: {
      type: Number,
      default: 30
    },
    top: {
      type: Number,
      default: 0
    },
    showCover: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {};
  }
});